import React from 'react';
import {
  CheckMarkOutlineIcon,
  ChevronDownOutlineIcon,
  CloseOutlineIcon,
  DocumentCheckOutlineIcon,
  DocumentXOutlineIcon,
  QuestionOutlineIcon,
  ClockOutlineIcon,
} from '~/icons';
import { IconType } from '~/utils';
import { Button, MenuButton } from '@applyboard/crystal-ui';
import { ApplicationStatus } from '../../../../data/useApplication';
import { DocumentSyncOutlineIcon, EditOutlineIcon, StudentOutlineIcon } from '@applyboard/ui-icons';
import type { ApplicationStatusActionCode } from '@applyboard/school-applications-types-lib';

type ActionGroup = ApplicationStatus['actionGroups'][number];
export type Action = ActionGroup['actions'][number];

type ActionGroupProps = {
  actionGroup: ActionGroup;
  onAction: (action: Action) => unknown;
};
export function ActionGroup(props: ActionGroupProps) {
  const [open, setOpen] = React.useState(false);
  const [isBusy, setIsBusy] = React.useState(false);
  const { actionGroup, onAction } = props;

  function onButtonClick(action: Action) {
    setIsBusy(true);
    Promise.all([onAction(action)])
      .catch(() => null)
      .finally(() => setIsBusy(false));
  }

  return (
    <MenuButton onOpenChange={(value) => setOpen(value)} open={open || isBusy} alignment="right">
      <MenuButton.Trigger>
        <Button
          intent="primary"
          trailIcon={ChevronDownOutlineIcon}
          loading={isBusy}
          width={{ xs: 'fill', sm: 'fill', md: 'hug' }}
          onClick={() => setOpen(true)}
        >
          {actionGroup.title}
        </Button>
      </MenuButton.Trigger>
      {actionGroup.actions.map((action) => (
        <MenuButton.Button
          key={action.nextStatus}
          id={action.nextStatus}
          disabled={isBusy}
          icon={ActionGroupMapping[action.code!] ?? IconsMapping[action.nextStatus]}
          onClick={() => onButtonClick(action)}
        >
          {action.label!}
        </MenuButton.Button>
      ))}
    </MenuButton>
  );
}

// TODO: A tech-debt here, we should somehow link the status to proper icon in BFF
const IconsMapping: Partial<Record<ApplicationStatus['code'], IconType | undefined>> = {
  DECLINED: CloseOutlineIcon,
  INITIAL_OFFER: CheckMarkOutlineIcon,
  READY_FOR_ASSESSMENT: DocumentXOutlineIcon,
  READY_FOR_SCREENING: DocumentCheckOutlineIcon,
  WAITLISTED: ClockOutlineIcon,
  FINAL_OFFER_ISSUED: CheckMarkOutlineIcon,
  ENROLMENT_CONFIRMED: StudentOutlineIcon,
  DEFERRAL_REQUESTED_IN_ASSESSMENT: undefined,
  DEFERRAL_REQUESTED_IN_INITIAL_OFFER: undefined,
  DEFERRAL_REQUESTED_IN_SCREENING: undefined,
};

const ActionGroupMapping: Partial<Record<ApplicationStatusActionCode, IconType | undefined>> = {
  UPDATE_PROGRAM_INTAKE: EditOutlineIcon,
  REQUEST_DOCUMENTS: QuestionOutlineIcon,
  REISSUE_OFFER: DocumentSyncOutlineIcon,
};
